import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index'
import PageNotFound from '@/components/PageNotFound'
import Battery from '@/components/Battery'
import Session from '@/components/Session'
import Dashboard from '@/components/Dashboard'
import Login from '@/components/Login'
import User from '@/components/User'
import Site from '@/components/Site'
import Comment from '@/components/Comment'
import Survey from '@/components/Survey'
import EmailSupport from '@/components/EmailSupport'
import BatteryDevice from '@/components/BatteryDevice'
import Device from '@/components/Device'
import Maps from '@/components/Map'
import StreamProfile from '@/components/StreamProfile'
import BatteryGradient from '@/components/BatteryGradient'
import Area from '@/components/Area'

Vue.use(Router)

export default new Router({
  mode: 'history',
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index,
      layout: 'empty',
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        isAuthenticated: false,
        layout: 'empty',
      },
    },
    {
      path: '/dashboard',
      redirect: {
        name: 'Dashboard',
      },
    },
    {
      path: '/dashboard/:id',
      name: 'Dashboard',
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/dashboard/:id/start/:start/end/:end',
      redirect: {
        name: 'Dashboard',
      },
    },
    {
      path: '/admin/users',
      name: 'User',
      component: User,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        layout: 'no-timeline',
      },
    },
    {
      path: '/admin/sites',
      name: 'Site',
      component: Site,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        layout: 'no-timeline',
      },
    },
    {
      path: '/comments',
      name: 'Comment',
      component: Comment,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path:
        '/comments/page/:page/count/:count/site/:site/language/:language/histopad_rating/:histopad_rating/visit_rating/:visit_rating/order/:order/list/:list/start/:start/end/:end/keyword/',
      redirect: {
        name: 'Comment',
      },
    },
    {
      path:
        '/comments/page/:page/count/:count/site/:site/language/:language/histopad_rating/:histopad_rating/visit_rating/:visit_rating/order/:order/list/:list/start/:start/end/:end/keyword/:keyword',
      redirect: {
        name: 'Comment',
      },
    },
    {
      path: '/stream/profiles',
      name: 'StreamProfile',
      component: StreamProfile,
      meta: {
        requiresAuth: true,
        layout: 'no-timeline',
      },
    },
    {
      path: '/survey',
      name: 'Survey',
      component: Survey,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/survey/site/:site',
      redirect: {
        name: 'Survey',
      },
    },
    {
      path: '/survey/site/:site/start/:start/end/:end',
      redirect: {
        name: 'Survey',
      },
    },
    {
      path:
        '/survey/site/:site/language/:language/histopad_rating/:histopad_rating/visit_rating/:visit_rating/collected_treasure_count/:collected_treasure_count/start/:start/end/:end',
      redirect: {
        name: 'Survey',
      },
    },
    {
      path: '/maps',
      name: 'Maps',
      component: Maps,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/maps/site/:site',
      redirect: {
        name: 'Maps',
      },
    },
    {
      path: '/maps/site/:site/start/:start/end/:end',
      redirect: {
        name: 'Maps',
      },
    },
    {
      path: '/maps/site/:site/level/:level/start/:start/end/:end',
      redirect: {
        name: 'Maps',
      },
    },
    {
      path:
        '/maps/site/:site/level/:level/language/:language/histopad_rating/:histopad_rating/visit_rating/:visit_rating/collected_treasure_count/:collected_treasure_count/start/:start/end/:end',
      redirect: {
        name: 'Maps',
      },
    },
    {
      path: '/areas',
      name: 'Areas',
      component: Area,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/areas/site/:site/area/:area',
      redirect: {
        name: 'Areas',
      },
    },
    {
      path: '/areas/site/:site/area/:area/start/:start/end/:end',
      redirect: {
        name: 'Areas',
      },
    },
    {
      path: '/support/email',
      name: 'EmailSupport',
      component: EmailSupport,
      meta: {
        requiresAuth: true,
        layout: 'no-timeline',
      },
    },
    {
      path: '/support/email/:email',
      redirect: {
        name: 'EmailSupport',
      },
    },
    {
      path: '/session/:session',
      name: 'Session',
      component: Session,
      meta: {
        requiresAuth: true,
        requiresHistovery: true,
        layout: 'no-timeline',
      },
    },
    {
      path: '/session/:session/site/:site',
      redirect: {
        name: 'Session',
      },
    },
    {
      path: '/battery/informations/:data_value/site/:site/date/:date',
      redirect: {
        name: 'Battery',
      },
    },
    {
      path: '/battery/informations/:data_value',
      name: 'Battery',
      component: Battery,
      meta: {
        requiresAuth: true,
        requiresHistovery: true,
        layout: 'no-timeline',
      },
    },
    {
      path: '/battery/level/device/:device/site/:site',
      name: 'BatteryDevice',
      component: BatteryDevice,
      meta: {
        requiresAuth: true,
        requiresHistovery: true,
      },
    },
    {
      path: '/battery/level/device/:device/site/:site/start/:start/end/:end',
      redirect: {
        name: 'BatteryDevice',
      },
    },
    {
      path: '/sessions',
      name: 'Device',
      component: Device,
      meta: {
        requiresAuth: true,
        requiresHistovery: true,
      },
    },
    {
      path: '/sessions/device/:device',
      redirect: {
        name: 'Device',
      },
    },

    {
      path: '/sessions/session/:session',
      redirect: {
        name: 'Device',
      },
    },
    {
      path:
        '/sessions/device/:device/session/:session/order/:order/site/:site/language/:language/histopad_rating/:histopad_rating/visit_rating/:visit_rating/collected_treasure_count/:collected_treasure_count/is_crash/:is_crash/state/:state/start/:start/end/:end',
      redirect: {
        name: 'Device',
      },
    },
    {
      path: '/battery/gradients',
      name: 'BatteryGradient',
      component: BatteryGradient,
      meta: {
        requiresAuth: true,
        requiresHistovery: true,
      },
    },
    {
      path: '/battery/gradients/site/:site',
      redirect: {
        name: 'BatteryGradient',
      },
    },
    {
      path: '/battery/gradients/start/:start/end/:end',
      redirect: {
        name: 'BatteryGradient',
      },
    },
    {
      path: '/battery/gradients/site/:site/start/:start/end/:end',
      redirect: {
        name: 'BatteryGradient',
      },
    },
    {
      path: '*',
      component: PageNotFound,
      name: 'PageNotFound',
      meta: {
        requiresAuth: false,
        layout: 'empty',
      },
    },
  ],
})
